import * as BridgeService from '@/services/bridge'

export const IS_DEVELOPMENT = process.env.REACT_APP_NODE_ENV === 'development'
export const IS_TEST = process.env.NODE_ENV === 'test'

export const ENABLE_MSW = IS_DEVELOPMENT && !BridgeService.inApp
